/**
 * Checks if a given country is the United States of America (USA).
 * @param country - The country to be checked.
 * @returns Returns true if the country is the United States of America (USA), false otherwise.
 */
export const isUSA = (country: string | null | undefined) => {
  if (!country) {
    return false;
  }
  return /^\s*(?:USA?|U\.S\.(?:A\.?)?|United States(?: of America)?)\s*$/i.test(country);
};
